const schema = () => ({
  title: 'Nous trouver',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['eyebrow', 'heading', 'full_width', 'map_height'],
    },
    {
      id: 'markers',
      title: 'Marqueurs',
      fields: ['markers'],
    },
    {
      id: 'distances',
      title: 'Distances',
      fields: ['distances'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Surtitre',
      type: 'string',
      default: 'Nous trouver',
    },
    heading: {
      title: 'Titre',
      type: 'string',
      default: 'À cinq minutes de la Grand-Place de Jodoigne.',
    },
    full_width: {
      title: 'Carte pleine largeur',
      type: 'boolean',
      default: false,
    },
    map_height: {
      title: 'Hauteur de la carte (px)',
      description: 'Laisser vide pour la hauteur par défaut (520px)',
      type: 'integer',
    },
    markers: {
      title: 'Points sur la carte',
      description:
        'Glissez les marqueurs pour définir leur position. Centrez la carte et cliquez « Ajouter ici » pour un nouveau point.',
      widget: 'markers_map',
    },
    distances: {
      title: 'Distances depuis les villes',
      widget: 'object_list',
      schema: {
        title: 'Ville',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['city', 'time'],
          },
        ],
        properties: {
          city: {
            title: 'Ville',
            type: 'string',
          },
          time: {
            title: 'Temps de trajet',
            description: 'Ex : 35 min',
            type: 'string',
          },
        },
        required: ['city', 'time'],
      },
    },
  },
  required: [],
});

export default schema;
